import { Maybe } from '@lib/types/Maybe';
import { Link } from '@lib/types/common/Link';
import { ReactNode } from 'react';
import { Link as LinkComponent } from 'ui-components';
import xss from 'xss';

type ErrorPageContentProps = {
  title: string;
  // May be an HTML string (e.g. from Sanity rich text) or a ReactNode
  description?: ReactNode;
  linksHeading?: Maybe<string>;
  links?: Link[];
  dataTest?: string;
};

export const ErrorPageContent = ({
  title,
  description,
  linksHeading,
  links,
  dataTest = 'error-404-not-found',
}: ErrorPageContentProps) => {
  return (
    <div className="container mb-32 mt-8">
      <h1 data-test={dataTest} className="text-2xl font-medium">
        {title}
      </h1>
      {typeof description === 'string' ? (
        <p
          className="text-2xl text-grey-500 dark:text-content-subtle"
          dangerouslySetInnerHTML={{ __html: xss(description) }}
        />
      ) : (
        <p className="text-2xl text-grey-500 dark:text-content-subtle">
          {description}
        </p>
      )}
      {linksHeading && (
        <h2 className="mt-4 text-sm text-grey-500 dark:text-content-subtle">
          {linksHeading}
        </h2>
      )}
      {links && links.length > 0 && (
        <ul className="mt-4">
          {links.map((link) => (
            <li key={link.href}>
              <LinkComponent href={link.href} className="text-sm text-link">
                {link.value}
              </LinkComponent>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
